export enum VacancyStatus {
	NoAction = "No Action",
	Converted = "Converted",
	Lost = "Lost",
	Cancelled = "Cancelled",
	InProgress = "In Progress",
}
